import { observer } from 'mobx-react';
import * as React from 'react';
import TranslatableTextDisplay from '../../Translations/TranslatableTextDisplay';
import { WizardStepItemLabel, WizardStepItemState } from './Types';
import WizardState from './WizardState';

interface Props {
  step: number;
  label: WizardStepItemLabel;
  state: WizardStepItemState;
}

const WizardStep: React.FC<Props> = ({ state, label, step }) => (
  <>
    <WizardState state={state} step={step}>
      <div className="text-sm text-gray-900">
        <TranslatableTextDisplay text={label} />
      </div>
    </WizardState>
  </>
);

export default observer(WizardStep);
